// -----------------------------------------------------------------------------
// API client — preferências per-usuário (`map-funnel-stage-and-add-ia-toggle`).
// -----------------------------------------------------------------------------

import axios from 'axios';
import type { Usuario } from '../types';

const baseURL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  '/api';

function authHeaders(): Record<string, string> {
  // Mesma key usada por `services/api.ts` e `context/AuthContext.tsx`.
  const token =
    typeof window !== 'undefined' ? window.localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface UserPreferencesPatch {
  aiAutoAttendEnabled: boolean;
  scope?: 'new_only' | 'include_inflight';
}

export interface PreferencesPatchResponse {
  usuario: Usuario;
  demotedCount?: number;
}

export async function getMyUsuario(): Promise<Usuario> {
  const { data } = await axios.get<Usuario>(`${baseURL}/usuarios/me`, {
    headers: authHeaders(),
  });
  return data;
}

export async function patchMyPreferences(
  patch: UserPreferencesPatch
): Promise<PreferencesPatchResponse> {
  const { data } = await axios.patch<PreferencesPatchResponse>(
    `${baseURL}/usuarios/me/preferences`,
    patch,
    { headers: authHeaders() }
  );
  return data;
}

export async function getMyIaActiveCount(): Promise<number> {
  const { data } = await axios.get<{ count: number }>(
    `${baseURL}/leads/me/ia-active-count`,
    { headers: authHeaders() }
  );
  return data.count;
}

export interface AutorunUserSummary {
  usuarioId: string;
  nome: string;
  email: string;
  role: Usuario['role'];
}

export async function getAutorunUsers(): Promise<AutorunUserSummary[]> {
  const { data } = await axios.get<{ usuarios: AutorunUserSummary[] }>(
    `${baseURL}/usuarios/autorun`,
    { headers: authHeaders() }
  );
  return data.usuarios;
}

export async function adminPatchUserPreferences(
  usuarioId: string,
  patch: UserPreferencesPatch
): Promise<PreferencesPatchResponse> {
  const { data } = await axios.patch<PreferencesPatchResponse>(
    `${baseURL}/usuarios/${usuarioId}/preferences`,
    patch,
    { headers: authHeaders() }
  );
  return data;
}
